<div class="body">
    <div class="container">
      <div class="row">
        <div class="col-sm-12 center">
          <img [src]="brand.loginLogo" [alt]="brand.brandName" class="logo-image" [style.width]="brand.loginLogoWidth" [style.margin-bottom]="brand.loginLogoMarginBottom">
        </div>
        <h3>Forgot Password</h3>
        <div class="col-sm-12 input-container-box">
          <form [formGroup]="form" (ngSubmit)="forgotPassword()">
            <div class="form-group input-container">
              <input type="text" formControlName="username" class="form-control input-field" placeholder="Username">
              <div class="alert msg-field" *ngIf="form.controls.username.touched && form.controls.username.errors && form.controls.username.errors.required">
                Username is required
              </div>
            </div>
            <div class="form-group input-container btn-container">
              <button [disabled]="loading" type="button" (click)="cancel()" class="btn btn-cancel">Cancel</button>
              <button [disabled]="loading || (form.controls.username.errors && form.controls.username.errors.required)" type="submit" class="btn btn-submit">Submit</button>
            </div>
            <div *ngIf="error" class="alert msg-field">{{error}}</div>
            <div *ngIf="success" class="success msg-field">{{success}}</div>
          </form>
        </div>
      </div>
    </div>
  </div>